import * as Session from '@svb/api-session-component/dist/components/session';
//callback from recentSearch to remove from local storage
const removeFromLocalStorage = (key, val, searchHistory) => {
    let arr = searchHistory; //get current localstorage values
    const getIndex = arr.findIndex(item => item.key === key && item.value === val);
    arr.splice(getIndex, 1);
    Session.setSessions('local', [
        {
            key: 'recent-searches',
            value: arr
        }
    ])
}

export default removeFromLocalStorage;